import { TaskPlanningInvoicingStatusCode } from '@enums/task-planning-invoicing-status-code.enum';

export const TASK_PLANNING_INVOICING_STATUS_LABEL: Record<TaskPlanningInvoicingStatusCode, string> = {
  [TaskPlanningInvoicingStatusCode.billable]: 'Facturable',
  [TaskPlanningInvoicingStatusCode.billed]: 'Facturé',
  [TaskPlanningInvoicingStatusCode.na]: 'Non applicable',
  [TaskPlanningInvoicingStatusCode.toBill]: 'À facturer immédiatement',
  [TaskPlanningInvoicingStatusCode.toBillOnDelivery]: 'À facturer à la livraison'
};
